"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scroll = void 0;
const defineChain_js_1 = require("../../utils/chain/defineChain.js");
exports.scroll = (0, defineChain_js_1.defineChain)({
    id: 534352,
    name: 'Scroll',
    network: 'scroll',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.scroll.io'],
            webSocket: ['wss://wss-rpc.scroll.io/ws'],
        },
        public: {
            http: ['https://rpc.scroll.io'],
            webSocket: ['wss://wss-rpc.scroll.io/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Scrollscan',
            url: 'https://scrollscan.com',
        },
        blockscout: {
            name: 'Blockscout',
            url: 'https://blockscout.scroll.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 14,
        },
    },
    testnet: false,
});
//# sourceMappingURL=scroll.js.map